export default {"src":"/_next/static/media/atlus.93e50638.gif","height":1920,"width":1080,"blurWidth":0,"blurHeight":0};